import React, {Component} from 'react'
import locale from './locale'
import './PaymentInformation.scss'

import {
	PanelWrapper,
} from 'components/UI'


class PaymentInformation extends Component {
  constructor(props){
    super(props)

    this.state = {

    }

  }

  componentDidMount(){

  }


  render(){
    return(
      <PanelWrapper className='payment-information-container'>
        <div>
          payment infomation

        </div>
      </PanelWrapper>
    )
  }
}

export default (PaymentInformation)



// WEBPACK FOOTER //
// ./src/containers/pages/PaymentInformation/index.js